import { Box, Grid, Typography } from '@mui/material';
import { FormikProps } from 'formik';
import React from 'react'

interface Props {
    formik: FormikProps<any>;
}

function ReviewForm({ formik }: Props) {

    const companyDetails = [
        { label: "Company Name", value: formik.values.companyName },
        { label: "Business Type", value:formik.values.businessType },
        { label: "Company Email", value: formik.values.companyEmail },
        { label: "Company Phone", value: formik.values.companyPhone },
        { label: "Website", value: formik.values.website },
        { label: "GST Number", value: formik.values.gstNumber },
        { label: "PAN Number", value: formik.values.panNumber },
        { label: "Registration Number", value: formik.values.registrationNumber },
    ];

    const addressDetails = [
        { label: "Address", value: formik.values.addressLine1 },
        { label: "City", value: formik.values.city },
        { label: "State", value: formik.values.state },
        { label: "Country", value: formik.values.country },
        { label: "Postal Code", value: formik.values.postalCode },
    ];

    const ownerDetails = [
        { label: "First Name", value: formik.values.firstName },
        { label: "Last Name", value: formik.values.lastName },
        { label: "Designation", value: formik.values.designation },
        { label: "Email", value: formik.values.email },
        { label: "Mobile Number", value: formik.values.mobileNumber },
        // { label: "Alternate Mobile Number", value: formik.values.alternateMobileNumber },
    ];
    return (
        <Grid className='p-xl-5 p-md-3 p-1 mt-2 mt-md-0' container spacing={2}>
            <Grid size={{ xs: 12, md: 6 }} className='border-main border-10 p-3'>
                <Box className='d-flex align-items-center justify-content-between'>
                    <Typography variant='h6' className='fw-bold'>Business Details</Typography>
                </Box>
                <Box className="mt-2">
                    {companyDetails.map((item) => (
                        <Grid
                            container
                            key={item.label}
                            className="justify-content-between mb-2"
                        >
                            <Grid size={"grow"} className="text-grey">
                                {item.label}
                            </Grid>
                            <Grid size={"grow"}>
                                {item.value || "-"}
                            </Grid>
                        </Grid>
                    ))}
                </Box>
            </Grid>
            <Grid size={{ xs: 12, md: 6 }} className='border-main border-10 p-3'>
                <Box className='d-flex align-items-center justify-content-between'>
                    <Typography variant='h6' className='fw-bold'>Address</Typography>
                </Box>
                <Box className="mt-2">
                    {addressDetails.map((item) => (
                        <Grid
                            container
                            key={item.label}
                            className="justify-content-between mb-2"
                        >
                            <Grid size={"grow"} className="text-grey">
                                {item.label}
                            </Grid>
                            <Grid size={"grow"}>
                                {item.value || "-"}
                            </Grid>
                        </Grid>
                    ))}
                </Box>
            </Grid>
            <Grid size={{ xs: 12, md: 6 }} className='border-main border-10 p-3'>
                <Box className='d-flex align-items-center justify-content-between'>
                    <Typography variant='h6' className='fw-bold'>Onwer Details</Typography>
                </Box>
                <Box className="mt-2">
                    {ownerDetails.map((item) => (
                        <Grid
                            container
                            key={item.label}
                            className="justify-content-between mb-2"
                        >
                            <Grid size={"grow"} className="text-grey">
                                {item.label}
                            </Grid>
                            <Grid size={"grow"}>
                                {item.value || "-"}
                            </Grid>
                        </Grid>
                    ))}
                </Box>
            </Grid>
            <Grid size={{ xs: 12, md: 6 }} className='border-main border-10 p-3'>
                <Box className='d-flex align-items-center justify-content-between'>
                    <Typography variant='h6' className='fw-bold'>Login Credentials</Typography>
                </Box>
                <Box className="mt-2">
                    <Grid
                        container

                        className="justify-content-between mb-2"
                    >
                        <Grid size={"grow"} className="text-grey">
                            Password
                        </Grid>
                        <Grid size={"grow"}>
                            {formik.values.password || "-"}
                        </Grid>
                    </Grid>
                </Box>
            </Grid>
        </Grid>
    )
}

export default ReviewForm
